<template>
  <app-layout>
    <v-card class="ma-3 pa-3">
      <!-- Resume -->
      <v-card-title class="pt-0">
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-layout align-center justify-start row fill-height>
              <div>
                <h2>Ventas</h2>
              </div>
              <div class="ml-3">
                <v-select
                  class="fit"
                  color="primary"
                  v-model="selectedYear"
                  item-text="text"
                  item-value="value"
                  :items="years"
                ></v-select>
              </div>
              <div class="ml-3">
                <v-select
                  class=""
                  color="primary"
                  v-model="selectedQuarter"
                  item-text="text"
                  item-value="value"
                  :items="quarters"
                ></v-select>
              </div>
              <div class="ml-3">
                <v-select
                  color="primary"
                  v-model="selectedCompanyStatus"
                  item-text="text"
                  item-value="value"
                  :items="companyStatuses"
                ></v-select>
              </div>
              <div class="ml-3">
                <v-select
                  color="primary"
                  v-model="selectedNonPayment"
                  item-text="text"
                  item-value="value"
                  :items="nonPaymentOptions"
                ></v-select>
              </div>
            </v-layout>
          </v-flex>
          <v-flex xs12 md6>
            <!-- Action buttons -->
            <v-layout align-center justify-end row fill-height>
              <div v-if="selectedTableItems.length >= 1">
                <v-btn color="green" @click="onUnblockInvoices()">
                  <v-icon left>mdi-alert-octagon</v-icon>
                  {{ $t('DESCONTABILIZAR FACTURAS') }}
                  <v-progress-circular
                    v-if="unblockingInvoices"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
                <v-btn color="red" @click="onBlockInvoices()">
                  <v-icon left>mdi-alert-octagon</v-icon>
                  {{ $t('CONTABILIZAR FACTURAS') }}
                  <v-progress-circular
                    v-if="blockingInvoices"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
                <v-btn color="info" @click="onBulkDownloadPdf()" :disabled="downloadingPDF">
                  <v-icon left>mdi-download</v-icon>
                  {{ $t('DESCARGAR PDF') }}
                  <v-progress-circular
                    v-if="downloadingPDF"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
                <v-btn color="light" @click="exportToExcel()" :disabled="exportingExcel">
                  <v-icon left>mdi-file-excel-outline</v-icon>
                  {{ $t('Exportar a excel') }}
                  <v-progress-circular
                    v-if="exportingExcel"
                    class="ml-2"
                    :size="20"
                    indeterminate
                    color="black"
                  ></v-progress-circular>
                </v-btn>
              </div>
            </v-layout>
            <!-- End action buttons -->
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <open-billing-invoice-table
          ref="openbillingInvoiceTable"
          :year="selectedYear"
          :quarter="selectedQuarter"
          :company-status="selectedCompanyStatus"
          :non-payment="selectedNonPayment"
          invoice-type="factura"
          @on-selected-items="onSelectedItems($event)"
          @on-show-invoice="onShowInvoice($event)"
          @on-download-pdf="onDownloadPdf($event)"
        ></open-billing-invoice-table>
      </v-card-text>
    </v-card>
    <open-billing-invoice-form
      v-if="showInvoiceModalForm"
      :show-modal="showInvoiceModalForm"
      :key="invoiceFormKey"
      :invoice-id="selectedInvoiceId"
      :invoice="selectedInvoice"
      invoice-type="factura"
      @click-on-close="closeInvoiceModalForm()"
    ></open-billing-invoice-form>
    <!-- Modal to block bulk invoices -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkBlockInvoiceModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Contabilizar facturas') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de contabilizar las facturas seleccionadas?
                  </h2>
                </v-flex>
                <v-flex xs12 class="text-xs-center">
                  <v-checkbox
                    v-model="sendConversationWhenBlockInvoices"
                    label="Enviar mensaje a los usuarios notificando que las facturas han sido contabilizadas"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showBulkBlockInvoiceModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmBlockBulkInvoices()">
              {{ $t('Contabilizar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <!-- Modal to unblock bulk invoices -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkUnblockInvoiceModal" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Descontabilizar facturas') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>
                    ¿Estás seguro de descontabilizar las facturas seleccionadas?
                  </h2>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showBulkUnblockInvoiceModal = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="confirmUnblockBulkInvoices()">
              {{ $t('Descontabilizar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->
    <v-snackbar v-model="snack" bottom right :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout';
import OpenBillingInvoiceTable from '@/modules/admin/billing/components/BillingAdminInvoiceTable';
import OpenBillingInvoiceForm from '@/modules/admin/billing/components/BillingAdminInvoiceForm';
import apiCtrl from '@/services/api/abstract/abstract-api';

export default {
  name: 'BillingAdminInvoiceSales',
  components: {
    AppLayout,
    'open-billing-invoice-table': OpenBillingInvoiceTable,
    'open-billing-invoice-form': OpenBillingInvoiceForm,
  },
  props: [],
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      years: [],
      quarters: [
        {
          text: 'Año completo',
          value: null,
        },
        {
          text: '1er Trimestre',
          value: 1,
        },
        {
          text: '2o Trimestre',
          value: 2,
        },
        {
          text: '3er Trimestre',
          value: 3,
        },
        {
          text: '4o Trimestre',
          value: 4,
        },
      ],
      selectedQuarter: null,
      companyStatuses: [
        { text: 'E. Activas', value: 'active' },
        { text: 'E. Inactivas', value: 'inactive' },
        { text: 'Todas', value: 'all' },
      ],
      selectedCompanyStatus: 'active',
      nonPaymentOptions: [
        { text: 'Sin impagos', value: 'false' },
        { text: 'Con impagos', value: 'true' },
      ],
      selectedNonPayment: 'false',
      totalAmountInvoiced: 0,
      totalAmountWithoutPay: 0,
      showInvoiceModalForm: false,
      showBulkBlockInvoiceModal: false,
      showBulkUnblockInvoiceModal: false,
      sendConversationWhenBlockInvoices: false,
      invoiceFormKey: 0,
      selectedInvoiceId: null,
      selectedInvoice: null,
      selectedTableItems: [],
      downloadingPDF: false,
      exportingExcel: false,
      blockingInvoices: false,
      unblockingInvoices: false,
      invoiceType: 'factura',
      invoiceLogo: null,
      snack: false,
      snackText: '',
      snackColor: 'info',
    };
  },
  mounted() {
    this.getYears();
  },
  computed: {},
  methods: {
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    getBillingInvoices() {
      this.$refs['openbillingInvoiceTable'].getBillingInvoices();
    },
    getYears() {
      const currentDate = new Date();
      let startYear = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;

      // If it is november or december we add the next year in the range
      if (month >= 11) {
        startYear = startYear + 1;
      }
      let years = [];
      for (let i = 10; i >= 0; i--) {
        years.push({ text: startYear - i, value: startYear - i });
      }
      this.years = years.sort((a, b) => b.value - a.value);
    },
    onSelectedItems(selectedItems) {
      this.selectedTableItems = selectedItems;
    },
    onShowInvoice(invoice) {
      this.selectedInvoiceId = invoice.id;
      this.selectedInvoice = invoice;
      this.showInvoiceModalForm = true;
    },
    closeInvoiceModalForm() {
      this.showInvoiceModalForm = false;
      this.selectedInvoiceId = null;
      this.selectedInvoice = null;
      this.invoiceFormKey++;
    },
    async onBulkDownloadPdf() {
      if (this.selectedTableItems.length === 0) {
        return;
      }

      this.downloadingPDF = true;
      try {
        const response = await apiCtrl.post(
          '/adminbilling/invoices/download-pdf',
          {
            selected_ids: this.selectedTableItems.map((invoice) => invoice.id),
          },
          { responseType: 'blob' },
        );
        this.downloadBlob(response.data, 'facturas_seleccionadas.pdf');
      } catch (error) {
        console.error('Error descargando PDFs:', error);
        this.showSnackMessage('error', 'No se han podido descargar las facturas');
      } finally {
        this.downloadingPDF = false;
      }
    },
    async onDownloadPdf(invoice) {
      this.downloadingPDF = true;
      try {
        await this.downloadInvoicePdf(invoice);
      } catch (error) {
        console.error('Error descargando PDF:', error);
        this.showSnackMessage('error', 'Se ha producido un error al descargar el PDF');
      }
      this.downloadingPDF = false;
    },
    async downloadInvoicePdf(invoice) {
      const invoiceData = await this.resolveInvoiceForPdf(invoice);
      const clavedat = this.getInvoiceClavedat(invoiceData);
      const response = await apiCtrl.get(
        `/openbilling/${clavedat}/invoices/${invoiceData.id}/download-pdf`,
        { responseType: 'blob' },
      );
      this.downloadBlob(response.data, `factura_${invoiceData.code || invoiceData.id}.pdf`);
    },
    async resolveInvoiceForPdf(invoice) {
      if (this.getInvoiceClavedat(invoice) !== 'null') {
        return invoice;
      }

      const response = await apiCtrl.get(`/openbilling/null/invoices/show/${invoice.id}`);
      return Object.assign({}, invoice, response.data.data);
    },
    getInvoiceClavedat(invoice) {
      return invoice && invoice.clavedat ? invoice.clavedat : 'null';
    },
    downloadBlob(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    async exportToExcel() {
      this.exportingExcel = true;
      import('../../../../plugins/Export2Excel.js').then(async excel => {
        const pagination = this.$refs['openbillingInvoiceTable'].invoicesPagination;
        const filters = this.$refs['openbillingInvoiceTable'].filters;
        let selectedIds = [];
        if (!this.$refs['openbillingInvoiceTable'].selectAllRows) {
          this.selectedTableItems.forEach(item => {
            selectedIds = selectedIds.concat(item['id']);
          });
        }
        const config = {
          params: {
            page: 1,
            per_page: -1,
            sort_by: pagination.sortBy,
            descending: pagination.descending,
            search: filters.search,
            status: filters.status,
            contact_id: filters.contact_id,
            month: filters.month,
            year: filters.year,
            clavedat: filters.clavedat,
            quarter: filters.quarter,
            payment_method: filters.payment_method,
            doc_type: filters.doc_type,
            selected_ids: selectedIds,
            blocked: filters.blocked,
            company_status: filters.company_status,
            non_payment: filters.non_payment,
          },
        };

        let headers = [];
        let dataToExport = [];
        await apiCtrl
          .get(`/adminbilling/invoices/list/export-excel`, config)
          .then(res => {
            console.log(res.data);
            headers = res.data.headers;
            dataToExport = res.data.data;
          })
          .catch(() => {
            this.showSnackMessage('error', 'Se ha producido un error al exportar los datos');
            this.exportingExcel = false;
          });
        let exportHeaders = headers.map(header => header.text);
        const exportColumns = headers.map(header => header.value);
        const exportList = this.formatJson(exportColumns, dataToExport);
        const quarterFileName = filters.quarter ? `Q${filters.quarter}` : 'año completo';
        excel.export_json_to_excel({
          header: exportHeaders,
          data: exportList,
          filename: `Reporte Facturas`,
          autoWidth: true,
          bookType: 'xlsx',
        });
        this.exportingExcel = false;
      });
    },
    onBlockInvoices() {
      const filters = this.$refs['openbillingInvoiceTable'].filters;
      if (filters.clavedat) {
        this.sendConversationWhenBlockInvoices = false;
        this.showBulkBlockInvoiceModal = true;
      } else {
        this.showSnackMessage('error', 'Es necesario seleccionar una empresa');
      }
    },
    onUnblockInvoices() {
      const filters = this.$refs['openbillingInvoiceTable'].filters;
      if (filters.clavedat) {
        this.showBulkUnblockInvoiceModal = true;
      } else {
        this.showSnackMessage('error', 'Es necesario seleccionar una empresa');
      }
    },
    async confirmBlockBulkInvoices() {
      this.showBulkBlockInvoiceModal = false;
      this.blockingInvoices = true;
      const pagination = this.$refs['openbillingInvoiceTable'].invoicesPagination;
      const filters = this.$refs['openbillingInvoiceTable'].filters;

      let selectedIds = [];
      if (!this.$refs['openbillingInvoiceTable'].selectAllRows) {
        this.selectedTableItems.forEach(item => {
          selectedIds = selectedIds.concat(item['id']);
        });
      }
      const config = {
        page: 1,
        per_page: -1,
        sort_by: pagination.sortBy,
        descending: pagination.descending,
        search: filters.search,
        status: filters.status,
        contact_id: filters.contact_id,
        month: filters.month,
        year: filters.year,
        clavedat: filters.clavedat,
        quarter: filters.quarter,
        payment_method: filters.payment_method,
        doc_type: filters.doc_type,
        selected_ids: selectedIds,
        send_message_after_block: this.sendConversationWhenBlockInvoices,
        blocked: filters.blocked,
        company_status: filters.company_status,
        non_payment: filters.non_payment,
      };

      await apiCtrl
        .post(`/adminbilling/invoices/block`, config)
        .then(res => {
          console.log(res.data);
          this.blockingInvoices = false;
          this.getBillingInvoices();
        })
        .catch(() => {
          this.showSnackMessage('error', 'Se ha producido un error al contabilizar las facturas');
          this.blockingInvoices = false;
        });
    },
    async confirmUnblockBulkInvoices() {
      this.showBulkUnblockInvoiceModal = false;
      this.unblockingInvoices = true;
      const pagination = this.$refs['openbillingInvoiceTable'].invoicesPagination;
      const filters = this.$refs['openbillingInvoiceTable'].filters;

      let selectedIds = [];
      if (!this.$refs['openbillingInvoiceTable'].selectAllRows) {
        this.selectedTableItems.forEach(item => {
          selectedIds = selectedIds.concat(item['id']);
        });
      }
      const config = {
        page: 1,
        per_page: -1,
        sort_by: pagination.sortBy,
        descending: pagination.descending,
        search: filters.search,
        status: filters.status,
        contact_id: filters.contact_id,
        month: filters.month,
        year: filters.year,
        clavedat: filters.clavedat,
        quarter: filters.quarter,
        payment_method: filters.payment_method,
        doc_type: filters.doc_type,
        selected_ids: selectedIds,
        send_message_after_block: this.sendConversationWhenBlockInvoices,
        blocked: filters.blocked,
        company_status: filters.company_status,
        non_payment: filters.non_payment,
      };

      await apiCtrl
        .post(`/adminbilling/invoices/unblock`, config)
        .then(res => {
          console.log(res.data);
          this.unblockingInvoices = false;
          this.getBillingInvoices();
        })
        .catch(() => {
          this.showSnackMessage(
            'error',
            'Se ha producido un error al descontabilizar las facturas',
          );
          this.unblockingInvoices = false;
        });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        }),
      );
    },
  },
  watch: {},
};
</script>

<style scoped>
.v-select.fit {
  width: min-content !important;
}
</style>
